import { render, staticRenderFns } from "./MstDeliveryDestGrpList.vue?vue&type=template&id=db56a348&scoped=true"
import script from "./MstDeliveryDestGrpList.vue?vue&type=script&lang=js"
export * from "./MstDeliveryDestGrpList.vue?vue&type=script&lang=js"
import style0 from "./MstDeliveryDestGrpList.vue?vue&type=style&index=0&id=db56a348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db56a348",
  null
  
)

export default component.exports